<template>
<div class="chapter">
<div class="inner_page">
<h2 class="title"><a id="page_i"></a>ENGLISH</h2>
<h2 class="title1">REBELS</h2>
<h2 class="title2">AND</h2>
<h2 class="title3">REVOLUTIONARIES</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?00e617d5